<template>
  <div class="dil-Wrapper">
    <div class="dil-Header">
      <div class="dil-Header_LeftSide">
        <template v-if="!hideActions">
          <SkeletonItem size="sm" width="120px" />
          <SkeletonItem size="sm" width="500px" />
        </template>
      </div>
      <div class="dil-Header_RightSide">
        <template v-if="!hideActions">
          <SkeletonItem size="sm" width="24px" />
          <SkeletonItem size="sm" width="1px" />
          <SkeletonItem size="sm" width="24px" />
          <SkeletonItem size="sm" width="24px" />
          <SkeletonItem size="sm" width="24px" />
        </template>
        <SkeletonItem size="sm" width="130px" />
      </div>
    </div>
    <div v-if="!hideTitle" class="dil-TitleWrapper">
      <SkeletonItem height="64px" width="800px" />
    </div>
    <div class="dil-ItemWrapper">
      <SkeletonItem border-radius="24px" height="330px" width="100%" />
    </div>
  </div>
</template>

<script setup>
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'DashboardItemLoader'
})

defineProps({
  // hides everything in the header except the add module button
  hideActions: {
    type: Boolean
  },

  hideTitle: {
    type: Boolean
  }
})
</script>

<style lang="scss" scoped>
.dil-Header {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--ob-dil-header-margin-bottom, 56px);
}
.dil-Header_LeftSide {
  display: flex;
  gap: 8px;
}
.dil-Header_RightSide {
  display: flex;
  gap: 16px;
}
.dil-TitleWrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  align-items: flex-end;
}
.dil-ItemWrapper {
  margin-bottom: 20px;
}
.dil-Wrapper {
  padding-left: $page-left-padding;
  padding-right: var(--ob-dil-page-right-padding, #{$page-right-padding});
  margin: var(--ob-dil-margin, 0);
}
</style>
